'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WinresCloudService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = require('../config');

var _utils = require('../core/utils.js');

var _utils2 = require('../webComponents/utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils2.getLog)('[WinresCloudService]');

var wrc = window.winresCloud;

// Service for authenticating and making WinresCloud requests.
// NOTE: This service notices 401 errors and broadcasts them to messages so
//       applications may redirect to login page or do something else if
//       session has expired.

var WinresCloudService = exports.WinresCloudService = function () {
    function WinresCloudService($http, userService, $injector, $q, $rootScope, $location, agentService, cancelService, localizationService) {
        _classCallCheck(this, WinresCloudService);

        this.$http = $http;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.userService = userService;
        this.agentService = agentService;
        this.cancelService = cancelService;
        this.localizationService = localizationService;

        // Information about the server we're using.
        // These will be requested when first needed.
        this.serverInfo = null;
        this.pendingServerInfo = null;

        var endpointOverride = (0, _utils.getParameter)('endpointOverride') || window.sessionStorage.getItem('endpointOverride');
        if ((0, _utils.getParameter)('noEndpointOverride')) {
            endpointOverride = false;
            window.sessionStorage.removeItem('endpointOverride');
        } else if (endpointOverride && _config.endpointOverrides[endpointOverride]) {
            window.sessionStorage.setItem('endpointOverride', endpointOverride);
            // From config.js
            this.endpoint = _config.endpointOverrides[endpointOverride];
            // log('Endpoint was set by endpointOverrides', endpointOverride, this.endpoint);
        } else if (wrc && wrc.endpoint && _config.endpoint.indexOf('//localhost') == -1) {
            // From winresCloud.endpoint if set and if config.js endpoint is not localhost.
            if (wrc.endpoint == 'https://varaamo6.matkaverkko.fi/Intres/lomalinja/WinresCloudService/feature-test-9/Cloud.svc/') {
                wrc.endpoint = 'https://varaamo6.matkaverkko.fi/Intres/lomalinja/WinresCloudService/production/Cloud.svc/';
            }
            this.endpoint = wrc.endpoint;
            // log('Endpoint was set by winresCloud.endpoint', this.endpoint);
        } else {
            // From config.js
            this.endpoint = _config.endpoint;
            // log('Endpoint was set by config.js', this.endpoint);
        }

        if (wrc) wrc.endpoint = this.endpoint;

        if ($injector.has('loadingOverlayService')) {
            this.loadingOverlayService = $injector.get('loadingOverlayService');
        }

        this.cachedRequests = {};
    }

    // requestName e.g. 'GetOwnerCustomerList', requestData object to pass to
    // the request. For authenticated requests, see makeAuthenticatedRequest.


    _createClass(WinresCloudService, [{
        key: 'makeRequest',
        value: function makeRequest(requestName, requestData, onSuccess, onError, withOverlay, responseType) {
            var _this = this;

            var cacheKey = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

            if (withOverlay && this.loadingOverlayService) {
                this.loadingOverlayService.start();
                jQuery('body').addClass('loading');
            }

            var request = void 0;
            if (this.cachedRequests[requestName + '-' + cacheKey] !== undefined) {
                request = this.cachedRequests[requestName + '-' + cacheKey];
            } else {
                // This can be used to cancel the request
                var canceler = this.$q.defer();

                request = this.getDefaultHeaders().then(function (headers) {
                    var config = {
                        timeout: canceler.promise,
                        headers: headers
                    };

                    if (responseType) {
                        config.responseType = responseType;
                    }

                    return _this.$http.post(_this.endpoint + requestName, requestData, config);
                });

                // Add a cancel method to the request. The method works by triggering the timeout promise.
                request.cancel = function () {
                    canceler.resolve();
                };

                // Mark the request as pending
                this.cancelService.register(request);

                request.then(function (x) {
                    return _this.cancelService.unregister(request);
                }, function (x) {
                    return _this.cancelService.unregister(request);
                });

                if (cacheKey !== undefined) {
                    // Cache request for later use.
                    this.cachedRequests[requestName + '-' + cacheKey] = request;
                }
            }

            return request.then(function (response) {
                // !! NOTE !! If you are here to debug why this function returns
                // undefined even if the request is being made, you probably have
                // incorrect case in the function name, e.g.
                // GetPaymentMethods instead of Getpaymentmethods or something.
                var result;
                if (responseType == 'blob' || responseType == 'arraybuffer') {
                    result = response.data;
                } else {
                    result = response.data[requestName + 'Result'];
                }
                if (withOverlay && _this.loadingOverlayService) {
                    _this.loadingOverlayService.stop();
                    jQuery('body').removeClass('loading');
                }

                if (onSuccess) {
                    onSuccess(result);
                }

                return result;
            }, function (err) {
                if (err.xhrStatus === "abort") {
                    // log("Request error handler: Request was cancelled.");
                    return;
                }
                if (err.status != 401) {
                    log.error('Error when making a Winres Cloud Request:', requestName, requestData, err);
                }
                if (withOverlay && _this.loadingOverlayService) {
                    _this.loadingOverlayService.stop();
                    jQuery('body').removeClass('loading');
                }

                if (onError) {
                    onError(err);
                }

                if (err.status == 401) {
                    log.warn('Unauthorized (probably session has expired):', requestName, requestData, err);
                    //Unauthorized. Session has expired.
                    _this.$rootScope.$broadcast('sessionExpired');
                }

                // Re-throw
                // Uncomment this to make request error catch handling functional.
                // Uncommenting this may break current error handling in web-components
                // and in Portal.
                // Uncomment this with your own risk.
                // throw err;
            });
        }

        // requestName e.g. 'GetOwnerCustomerList', requestData object to pass to
        // the request. For authenticated requests, see makeAuthenticatedRequest.

    }, {
        key: 'makeRequestWithResponse',
        value: function makeRequestWithResponse(requestName, requestData) {
            var _this2 = this;

            // This can be used to cancel the request
            var canceler = this.$q.defer();

            var request = this.getDefaultHeaders().then(function (headers) {
                var config = {
                    timeout: canceler.promise,
                    headers: headers
                };

                return _this2.$http.post(_this2.endpoint + requestName, requestData, config);
            });

            // Add a cancel method to the request. The method works by triggering the timeout promise.
            request.cancel = function () {
                canceler.resolve();
            };

            // Mark the request as pending
            this.cancelService.register(request);

            return request.then(function (response) {
                _this2.cancelService.unregister(request);
                return response.data[requestName + 'Result'];
            }, function (err) {
                _this2.cancelService.unregister(request);
                if (err.xhrStatus === "abort") {
                    log("HTTP: Request was cancelled.");
                    return;
                }
                if (err.status != 401) {
                    log.error('[WRC] HTTP: Error:', requestName, requestData, err);
                }
                if (err.status == 401) {
                    log.warn('HTTP: Unauthorized. Session may have expired.', requestName, requestData, err);
                    //Unauthorized. Session has expired.
                    _this2.$rootScope.$broadcast('sessionExpired');
                }

                // Re-throw
                throw err;
            });
        }
    }, {
        key: 'makeAuthenticatedRequestWithResponse',
        value: function makeAuthenticatedRequestWithResponse(requestName, requestData) {
            var _this3 = this;

            if (!this.userService.getCurrentUser()) {
                log('Not logged in - delaying request:', requestName);
                // Wait for login to finish, then make the request. This is
                // relevant in webComponents where the component logins and then
                // immediately begins executing other code.
                return this.$q(function (resolve, reject) {
                    _this3.$rootScope.$on('login', function () {
                        log('User logged in - Doing a delayed request:', requestName);
                        resolve();
                    });
                }).then(function () {
                    return _this3.makeAuthenticatedRequestWithResponse(requestName, requestData);
                });
            }

            if (!requestData) {
                requestData = {};
            }

            return this.makeRequestWithResponse(requestName, this.authenticateRequest(requestData));
        }

        // Adds Auth and SessionID to the request.

    }, {
        key: 'makeAuthenticatedRequest',
        value: function makeAuthenticatedRequest(requestName, requestData, withOverlay, responseType, cacheKey, onError) {
            var _this4 = this;

            var t = this;
            if (!this.userService.getCurrentUser()) {
                log('Not logged in - delaying request:', requestName);
                // Wait for login to finish, then make the request. This is
                // relevant in webComponents where the component logins and then
                // immediately begins executing other code.
                return this.$q(function (resolve, reject) {
                    _this4.$rootScope.$on('login', function () {
                        log('User logged in - Doing a delayed request:', requestName);
                        resolve();
                    });
                }).then(function () {
                    return t.makeAuthenticatedRequest(requestName, requestData, withOverlay, responseType);
                });
            }

            if (!requestData) {
                requestData = {};
            }

            return this.makeRequest(requestName, this.authenticateRequest(requestData), false, onError, withOverlay, responseType, cacheKey);
        }

        // Returns authenticated data.

    }, {
        key: 'authenticateRequest',
        value: function authenticateRequest(requestData) {
            requestData = _.clone(requestData);
            // Removed as unsafe.
            //requestData.Auth = this.userService.getCurrentUser().getAuth();
            requestData.SessionID = this.userService.getCurrentUser().getSessionId();
            requestData.Agent = {
                OfficeID: this.agentService.officeID,
                ClerkID: this.agentService.clerkID,
                Timestamp: this.agentService.timestamp
            };
            return requestData;
        }

        // Perform a request with Bearer and legacy X-Winres-Session-ID authentication.
        // As authenticated requests are the default situation and unauthenticated ones
        // the special case, this has the shorter name.
        // See below for shorthand functions.

    }, {
        key: 'request',
        value: function request(method, path, customConfig) {
            var authHeadersPromise = this.getUserWhenAvailable().then(function (user) {
                return {
                    'Authorization': 'Bearer ' + user.getSessionId(),
                    'X-Winres-Session-ID': user.getSessionId() // Legacy
                };
            });
            return this.requestInternal(method, path, customConfig, authHeadersPromise);
        }
    }, {
        key: 'requestUnauthenticated',
        value: function requestUnauthenticated(method, path, customConfig) {
            var authHeadersPromise = this.$q.resolve({});
            return this.requestInternal(method, path, customConfig, authHeadersPromise);
        }
    }, {
        key: 'requestInternal',
        value: function requestInternal(method, path, customConfig, authHeadersPromise) {
            var _this5 = this;

            customConfig = customConfig || {};

            var deferred = this.$q.defer();

            var result = authHeadersPromise.then(function (authHeaders) {
                var canceler = _this5.$q.defer();

                var request = _this5.getDefaultHeaders().then(function (defaultHeaders) {
                    var config = _.assign({}, customConfig, {
                        method: method,
                        url: _this5.endpoint + path,
                        data: customConfig.data,
                        headers: _.assign({}, customConfig.headers || {}, defaultHeaders, authHeaders),
                        timeout: canceler.promise,
                        eventHandlers: {},
                        uploadEventHandlers: {
                            progress: function progress(event) {
                                return deferred.notify({ type: 'upload-progress', event: event });
                            }
                        },
                        cache: customConfig.cache
                    });
                    return _this5.$http(config);
                });

                request.cancel = function () {
                    canceler.resolve();
                };

                _this5.cancelService.register(request);

                return request.then(function (result) {
                    _this5.cancelService.unregister(request);
                    return result;
                }, function (error) {
                    _this5.cancelService.unregister(request);
                    if (error.status == 401) {
                        // 401 Unauthorized. This means we provided the correct
                        // authentication header, but the server didn't accept it.
                        // This probably means the session is expired (but could
                        // also mean we're somehow connecting to a different server
                        // then the one we logged on to before).
                        _this5.$rootScope.$broadcast('sessionExpired');
                    }
                    // Re-throw
                    throw error;
                });
            });

            deferred.resolve(result);

            return deferred.promise;
        }
    }, {
        key: 'get',
        value: function get(path, customConfig) {
            return this.request('GET', path, customConfig);
        }
    }, {
        key: 'delete',
        value: function _delete(path, customConfig) {
            return this.request('DELETE', path, customConfig);
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            var user = this.getUser();
            return !!user;
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            return this.userService.getCurrentUser();
        }
    }, {
        key: 'getUserWhenAvailable',
        value: function getUserWhenAvailable() {
            return this.userService.getUserWhenAvailable();
        }
    }, {
        key: 'getEndpoint',
        value: function getEndpoint() {
            return this.endpoint;
        }
    }, {
        key: 'getLanguage',
        value: function getLanguage() {
            return this.localizationService.getLanguage();
        }

        // Return a promise resolving to the the headers that should be set for
        // every WRC request.

    }, {
        key: 'getDefaultHeaders',
        value: function getDefaultHeaders() {
            var _this6 = this;

            return this.getServerInfo().then(function (info) {
                var headers = {
                    // Set in Webpack serve/build process
                    'X-WRC-Frontend': WRC_FRONTEND_VERSION

                    // Don't add this yet, would required Cloud config change too
                    // 'Accept-Language': this.localizationService.getLanguage()
                };

                if (info.acceptsCustomReferer) {
                    headers['X-WRC-Referer'] = _this6.getReferer();
                }

                return headers;
            });
        }
    }, {
        key: 'getServerInfo',
        value: function getServerInfo() {
            var _this7 = this;

            if (this.serverInfo) {
                // Already requested and the request has finished
                return this.$q.resolve(this.serverInfo);
            } else if (this.pendingServerInfo) {
                // Already requested but the request hasn't finished yet
                return this.pendingServerInfo;
            } else {
                // Not yet requested at all
                this.pendingServerInfo = this.fetchServerInfo().then(function (info) {
                    // log('Got server info:', info);
                    _this7.serverInfo = info;
                    _this7.pendingServerInfo = null;
                    return info;
                });
                return this.pendingServerInfo;
            }
        }
    }, {
        key: 'fetchServerInfo',
        value: function fetchServerInfo() {
            var config = {
                method: 'OPTIONS',
                url: this.endpoint
            };
            var request = this.$http(config);

            return request.then(function (response) {
                var allowHeaders = response.headers('Access-Control-Allow-Headers');

                return {
                    acceptsCustomReferer: _.includes(allowHeaders, 'X-WRC-Referer')
                };
            }, function (error) {
                // Default values in case it failed somehow
                return {
                    acceptsCustomReferer: false
                };
            });
        }
    }, {
        key: 'getReferer',
        value: function getReferer() {
            return this.$location.absUrl();
        }
    }]);

    return WinresCloudService;
}();

WinresCloudService.$inject = ['$http', 'userService', '$injector', '$q', '$rootScope', '$location', 'agentService', 'cancelService', 'localizationService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/winresCloudService.js
// module id = 555
// module chunks = 2